import { apiClient } from './api'

export interface ProjectBudgetSummary {
  project_id: number
  project_name: string
  total_budget: number
  spent_budget: number
  committed_budget: number
  remaining_budget: number
  utilization_rate: number
  project_start_date: string | null
  project_end_date: string | null
  progress: number
  time_progress: number
  monthly_data: Array<{
    month: string
    month_date: string | null
    planned: number
    actual: number
    forecast: number
  }>
  gates_data: Array<{
    gate: string
    planned: number
    actual: number
    forecast: number
  }>
  budget_by_category: Array<{
    category: string
    allocated: number
    spent: number
    committed: number
    color: string
  }>
  recent_transactions: Array<{
    id: number
    date: string
    category: string
    description: string
    amount: number
    status: string
  }>
  milestones: Array<{
    phase: string
    budget: number
    spent: number
    status: string
    progress: number
  }>
  projected_end_of_project: number
  variance_end_of_project: number
  projected_end_of_year: number
  variance_end_of_year: number
}

export const projectBudgetService = {
  async getSummary(projectId: number): Promise<ProjectBudgetSummary> {
    const { data } = await apiClient.get<ProjectBudgetSummary>(
      `/api/v1/projects/${projectId}/budget/summary`
    )
    return data
  },
}
